import { Button, Heading } from '@lmc/ui-kit'
import { NAMESPACE } from 'locale'
import { selfServeConstants } from 'locale/selfServe'
import type { FC } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

type Props = {
  onClick?: () => void
}

export const StartStepCard: FC<Props> = ({ onClick }) => {
  const { t } = useTranslation(NAMESPACE.SELF_SERVE)

  return (
    <CardWrapper className="lmc-home-card">
      <StyledHeading level={3}>
        {t(selfServeConstants.START_STEP_TITLE)}
      </StyledHeading>
      <StyledHeadingDesc level={5}>
        {t(selfServeConstants.START_STEP_DESC)}
      </StyledHeadingDesc>
      <StyledButton variant="popout" onClick={onClick}>
        {t(selfServeConstants.START)}
      </StyledButton>
    </CardWrapper>
  )
}

const CardWrapper = styled.div`
  background-color: #fff8fa;
  padding: 24px;
  border-radius: 20px;
  margin-top: 18px;
  display: flex;
  flex-direction: column;
`

const StyledHeading = styled(Heading)`
  color: ${({ theme }) => theme.color.status.popout};
  font-weight: 400;
  margin-bottom: 5px;
`

const StyledHeadingDesc = styled(Heading)`
  color: ${({ theme }) => theme.color.neutral.color4};
`

const StyledButton = styled(Button)`
  margin-bottom: 0px;
  margin-top: auto;
  width: fit-content;
  margin-left: auto;
`
